import React, { Fragment } from 'react'

function Terms() {
    return (
        <Fragment>
            <div className="title">Terms & Privacy</div>
            (Updated September 18, 2017)
            <div className="header-text">1. Disclaimer Of Liability</div>
            <p>
                1.1 The owners of the website the Stoke List (“the Stoke List”)
                are not liable for the accuracy nor honesty of any postings
                presented on this site. Users are cautioned to verify the
                accuracy of ALL information posted to his/her own satisfaction.
                We make no representations or warranties of any kind, express or
                implied about the completeness, accuracy, reliability or
                suitability of any items for sale or any commentary made, in any
                form whatsoever, on the website. Any reliance you place on such
                material is therefore strictly at your own risk.
            </p>
            <p>
                1.2. The Stoke List will not be a party to or in any way be
                responsible for monitoring any transaction between you and
                third-party providers of products or services. As with the
                purchase of a product or service through any medium or in any
                environment, you should use your best judgment and exercise
                caution where appropriate.
            </p>
            <p>
                1.3 We will not be liable for any false, inaccurate,
                inappropriate or incomplete information presented on the
                website.
            </p>
            <p>
                1.4 Although every effort is made to keep the website up and
                running smoothly, due to the nature of the Internet and the
                technology involved, we take no responsibility for and will not
                be liable for the website being temporarily unavailable due to
                technical issues (or otherwise) beyond its control or for any
                loss or damage suffered as a result of the use of or access to,
                or inability to use or access this website whatsoever.
            </p>
            <p>
                1.5 Under no circumstances shall the Stoke List be liable to you
                or any other third parties for any loss or damage (including,
                without limitation, damage for loss of business or reputation,
                personal injury or property damage) arising directly or
                indirectly from content posted on the website.
            </p>
            <p>
                1.6 The opinions expressed by Stoke List posters and those
                providing comments are theirs alone, and do not reflect the
                opinions of the Stoke List. The Stoke List is not responsible
                for the accuracy of any of the information supplied by posters
                or in relation to any comments that are posted.
            </p>
            <p>
                1.7 The Stoke List will not tolerate defamatory or libellous
                material, obscene content and abusive or intimidating comments.
                The Stoke List and its moderators monitor comments on this
                website and may remove any material from the website at its sole
                discretion, without warning and without prejudice to any other
                accrued rights. 1.8 The Stoke List shall not be liable for any
                loss or damage which may occur as a result of any virus, bug,
                trojan horse, breach of security, or the like which may be
                transmitted to or through our services by any third party,
            </p>
            <p>
                1.9 The Stoke List cannot accept responsibility for any
                unauthorized access or loss of personal information that is
                beyond the control of the Stoke List. 1.10 The Stoke List does
                not warrant, endorse, guarantee, or assume responsibility for
                any product or service advertised or offered by a third party
                through the services, or featured in any banner or other
                advertising.
            </p>
            <div className="header-text">2. Privacy</div>
            <p>
                2.1 The Stoke List has put in place reasonable electronic
                measures to protect your information from loss, theft, and
                unauthorized access, disclosure, copying, use, or modification.
            </p>
            <p>
                2.2 The Stoke List may disclose your personal information if we
                need to comply with applicable laws and lawful governmental
                requests, other legal and regulatory authorities or for other
                legal reasons.
            </p>
        </Fragment>
    )
}

export default Terms
